module.exports = __webpack_public_path__ + "img/fk.c63ee1c8.png";